import React from 'react';
import { useNavigate } from 'react-router-dom';

const QuickActions = ({ onActionComplete }) => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Daily Check-in',
      description: 'Track your mood and wellness',
      icon: '📝',
      color: 'blue',
      action: () => navigate('/checkin')
    },
    {
      title: 'Start Questionnaire',
      description: 'Complete health assessment',
      icon: '📋',
      color: 'green',
      action: () => navigate('/questionnaire')
    },
    {
      title: 'Chat with AI',
      description: 'Get instant support',
      icon: '🤖',
      color: 'purple',
      action: () => navigate('/chatbot')
    },
    {
      title: 'View Analytics',
      description: 'See your progress',
      icon: '📊',
      color: 'orange',
      action: () => navigate('/analytics')
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-700 hover:bg-blue-200',
    green: 'bg-green-100 text-green-700 hover:bg-green-200',
    purple: 'bg-purple-100 text-purple-700 hover:bg-purple-200',
    orange: 'bg-orange-100 text-orange-700 hover:bg-orange-200'
  };

  return (
    <div className="space-y-3">
      {actions.map((action, index) => (
        <button
          key={index}
          onClick={() => {
            action.action();
            if (onActionComplete) onActionComplete();
          }}
          className={`w-full text-left p-3 rounded-lg transition-colors ${colorClasses[action.color]}`}
        >
          <div className="flex items-center">
            <span className="text-2xl mr-3">{action.icon}</span>
            <div>
              <h4 className="font-medium">{action.title}</h4>
              <p className="text-sm opacity-75">{action.description}</p>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;
